export default () => {
  const awardsRow = document.getElementById('awards-row');

  if (awardsRow === null || awardsRow.childNodes.length < 2) {
    return;
  }

  const leftColumnChildren = awardsRow.childNodes[0].children;
  const rightColumnChildren = awardsRow.childNodes[1].children;

  if (leftColumnChildren.length < 2 || rightColumnChildren.length < 1) {
    return;
  }

  function adjustHeights() {
    let rightHeight = 0;
    let leftHeight = 0;
    let startHidding = false;

    [].forEach.call(rightColumnChildren, el => {
      rightHeight += el.offsetHeight;
    });

    [].forEach.call(leftColumnChildren, el => {
      el.removeAttribute('style');
      leftHeight += el.offsetHeight;

      if (startHidding) {
        // eslint-disable-next-line no-param-reassign
        el.style.display = 'none';
      }

      if (leftHeight > rightHeight) {
        startHidding = true;
      }
    });
  }

  adjustHeights();

  let resizeTimeout = null;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(adjustHeights, 200);
  });
  window.addEventListener('load', adjustHeights);
};



// WEBPACK FOOTER //
// ./src/scripts/modules/awards-rows.js